import { useContext } from "react";
import { TemplateContext } from "../../../../contexts/TemplateContext";
import { PentestContext } from "../../../../contexts/PentestContext";

export const useVariableMap = () => {
  const { template } = useContext(TemplateContext);
  const { pentest, pentestVulns } = useContext(PentestContext);
  const vulnerabilities = pentestVulns;
  return {
    "client": pentest?.Client,
    "start-date": pentest?.StartDate,
    "end-date": pentest?.EndDate,
    "type": pentest?.Type,
    "category": pentest?.Category,

    "contact-name": template?.ContactInformation?.Name,
    "phone": template?.ContactInformation?.PhoneNumber,
    "email": template?.ContactInformation?.Email,
    "company": template?.ContactInformation?.Company,

    "motto": template?.Motto,
    "vulnerabilities-count": vulnerabilities.length.toString(),
  };
};
